import { AccountInfoData } from 'types';

/** Master switch for farm invite UI surfaces in the user portal. */
export const FARM_USER_INVITE_UI_ENABLED = true;

/**
 * Whether the signed-in user may invite colleagues to the selected farm.
 * Matches backend FarmInviteAccessService (farm owner or org owner/admin).
 */
export const canInviteFarmUsers = (accountInfo?: AccountInfoData): boolean =>
  FARM_USER_INVITE_UI_ENABLED && Boolean(accountInfo?.canInviteFarmUsers);
